import type { ITimestamp } from '../../types/common';

import type { ProjectGroup, ProjectGroupReleaseProject, ProjectGroupReleaseScan } from '.';

export const AttributionTextReportPublicationStatuses = ['attribution_txt'] as const;
export const TextReportPublicationStatuses = ['spdx_tagged'] as const;
export const JSONReportPublicationStatuses = ['cyclonedx_json', 'spdx_json'] as const;
export const XMLReportPublicationStatuses = ['cyclonedx_xml'] as const;
export const PublishedReportPublicationStatuses = [
  ...AttributionTextReportPublicationStatuses,
  ...TextReportPublicationStatuses,
  ...JSONReportPublicationStatuses,
  ...XMLReportPublicationStatuses,
] as const;
export const ReportPublicationStatuses = [
  'pending',
  ...PublishedReportPublicationStatuses,
] as const;
export type ReportPublicationStatus = typeof ReportPublicationStatuses[number];
export const ReportPublicationStatusToString: Record<ReportPublicationStatus, string> = Object.freeze({
  attribution_txt: 'Attribution (Text)',
  pending: 'Pending',
  spdx_tagged: 'SPDX (tag/value)',
  spdx_json: 'SPDX (JSON)',
  cyclonedx_xml: 'CycloneDX (XML)',
  cyclonedx_json: 'CycloneDX (JSON)',
});

export type ProjectGroupRelease = ITimestamp & {
  id: number;
  title: string;
  projectGroupId: number;
  dependency_count: number | null;
  license_count: number | null;
  unresolved_licensing_issue_count: number | null;
  unresolved_security_issue_count: number | null;
  unresolved_quality_issue_count: number | null;
  publishedOnPortal: ReportPublicationStatus | null;
  publishedAt: Date | null;
  reportPath: string | null;
  publishedLicenses: string[] | null;

  /**
   * Associations
   */
  group?: ProjectGroup;
  projects?: ProjectGroupReleaseProject[];
  scans?: ProjectGroupReleaseScan[];
}
